import React from 'react';
import { Alert, Container } from 'react-bootstrap';
import { useUser } from '../components/UserContext.tsx';
import SchoolLabBanner from './SchoolLabBanner.tsx';

type Props = {
  title: string;
  children: React.ReactNode;
};

export default function SchoolDeskPage({ title, children }: Props) {
  const { activeUser } = useUser();
  return (
    <div className="main-content">
      <SchoolLabBanner user={activeUser} />
      <Container className="my-4">
        <h1 className="display-6">{title}</h1>
        <Alert variant="warning">
          Solbakken laboratory — phrase-list stub, not a hosted model, not a pilot.
        </Alert>
        {children}
      </Container>
    </div>
  );
}
